const items = state => state.items.data
const profile = state => {
  return state.profile
}
const checkEmail = state => state.checkEmail.data
const errorCheckEmail = state => state.errorCheckEmail.data
const error = state => state.error.data
const isLoading = state => state.isLoading
const isAuth = state => !!state.token

const guestPersonal = state => state.guestPersonal.data
const errorGuestPersonal = state => state.errorGuestPersonal
const isLoadingGuestPersonal = state => state.isLoadingGuestPersonal

const getListArea = state => state.getListArea.data
const errorGetListArea = state => state.errorGetListArea
const isLoadingGetListArea = state => state.isLoadingGetListArea

const getListIndustry = state => state.getListIndustry.data
const errorGetListIndustry = state => state.errorGetListIndustry
const isLoadingGetListIndustry = state => state.isLoadingGetListIndustry

const getListTradeRole = state => state.getListTradeRole.data
const errorGetListTradeRole = state => state.errorGetListTradeRole
const isLoadingGetListTradeRole = state => state.isLoadingGetListTradeRole

const dialcode = state => state.dialcode
const errorDialcode = state => state.errorDialcode
const isLoadingDialcode = state => state.isLoadingDialcode

const checkResetpwd = state => state.checkResetpwd.data
const errorCheckResetpwd = state => state.errorCheckResetpwd
const isLoadingCheckResetpwd = state => state.isLoadingCheckResetpwd

export default {
  isLoading,
  profile,
  items,
  error,
  isAuth,
  checkEmail,
  errorCheckEmail,
  guestPersonal,
  errorGuestPersonal,
  isLoadingGuestPersonal,

  getListArea,
  errorGetListArea,
  isLoadingGetListArea,

  getListIndustry,
  errorGetListIndustry,
  isLoadingGetListIndustry,

  getListTradeRole,
  errorGetListTradeRole,
  isLoadingGetListTradeRole,

  dialcode,
  errorDialcode,
  isLoadingDialcode,

  checkResetpwd,
  errorCheckResetpwd,
  isLoadingCheckResetpwd
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js